import { Component } from '@angular/core';
import { MessageService, SelectItemGroup, TreeNode } from 'primeng/api';
import { ProductModule, ProductModuleRequest, ProductTrackService } from 'src/app/shared/services/product-module.service';
import { Category, Item, ProductResponse, ProductsService, Type } from 'src/app/shared/services/products.service';


interface Column {
  field: string;
  header: string;
  placeholders: string;
}

@Component({
  selector: 'app-product-track',
  templateUrl: './productModule.component.html',
  styleUrl: './productModule.component.scss'
})
export class ProductModuleComponent {

  // tree
  files!: TreeNode<any>[];
  cols!: Column[];
  productSelected : any=null;
  // dialog sub products
  visible: boolean = false;

  
  // dialog Create or Update
  visibleDialog: boolean = false;
  dialogTitle: string = 'Add Product Module';

  // dialog Data 
  selectedCategory: any ;
  selectedType: any ;
  selectedItem: any ;
  selectedProductId: number ;
  MaoduleName: string;
  MaoduleNumber: string;
  description: string;
  selectedParent: any;
  parentsOptions: any[] = [] ;
  selectProductModuleId: number;

  // edit dialog create or update
  categoriesByKind: any[] = [];
  licenseCategories: Category[] = [];
  serviceCategories: Category[] = [];
  productsResponse: ProductResponse;
  groupedCategories: SelectItemGroup[] = [];
  typesByCategory: Type[] = [];
  itemsByType: Item[] = [];

  //  
  sourceProducts: any[] = [
    { name: 'Product 1' },
    { name: 'Product 2' },
    { name: 'Product 3' },
  ];

  targetProducts: any[] = [];

  constructor(private productModuleService:ProductTrackService , 
     private messageService: MessageService , 
     private productsService: ProductsService ) { }

  ngOnInit(): void {
    
    
    this.loadData();
    this.cols = [
      { field: 'moduleName', header: 'Module Name' ,placeholders: 'Module Name' },
      { field: 'moduleNumber', header: 'Module Number' ,placeholders: 'Module Number' },
      { field: 'description', header: 'Description' ,placeholders: 'Description' },
      { field: 'productCategory', header: 'Category' ,placeholders: 'Category' },
      { field: 'productType', header: 'Type'  ,placeholders: 'Type' },
      { field: 'productItem', header: 'Item'  , placeholders: 'Item' },
      { field: 'partNumber', header: 'Part Number' , placeholders: 'Part Number' },
      { field: '', header: 'Actions' ,  placeholders: 'Actions' }

    ];

    this.loadProducts();
  }


  // load data
  loadData() {
    this.productModuleService.getProductMosules().subscribe((data: any[]) => {
      // console.log(data);
      this.files = data.map((product) => ({
        data: product,
        children: (product.children || []).map(child => ({ data: child, children: [] }))
      })).filter(product => product.data.parentId === null);
    
      // console.log(this.files);
    });

 
  }

  loadProducts() {
    this.productsService.getProductsByKind('all').subscribe((data: ProductResponse) => {
      // console.log(data);
      this.productsResponse = data;
      this.categoriesByKind = this.transformCategories(data);
    });
  }

  // dialog sub products
  showDialog(partNumber: string) {
    this.sourceProducts = this.files
      .filter(product => product.data.partNumber !== partNumber)
      .map(product => product.data);

    const selectedProduct = this.files.find(product => product.data.partNumber === partNumber);
    this.targetProducts = selectedProduct ? selectedProduct.children.map(child => child.data) : [];
  
    this.visible = true;
    this.productSelected = selectedProduct;
  }

  // dialog sub products
  saveSelectedProduct() {
    if (this.productSelected) {
      const productToUpdate = this.files.find(product => product.data.partNumber === this.productSelected.data.partNumber);
      if (productToUpdate) {
        productToUpdate.children = this.targetProducts.map(item => ({ data: item, children: [] })); // or adjust as needed
      }
      this.visible = false;
    } else {
      console.warn('No product selected.');
    }
  }


  // dialog Create or Update

  handleSelectionChanged(selection: any) {

    this.selectedCategory = selection.category;
    this.selectedType = selection.type;
    this.selectedItem = selection.item;
    this.selectedProductId = selection.selectedProductId;

    // Log the values or perform further actions
    // console.log('Selected category:', this.selectedCategory);
    // console.log('Selected type:', this.selectedType);
    // console.log('Selected item:', this.selectedItem);
    // console.log('Selected product ID:', this.selectedProductId);

  }

  showDialogForCreateOrUpdate() {
    this.parentsOptions = this.files.filter(product => product.data.parentId=== null ).map(product => product.data);
    // console.log(this.parentsOptions);
    this.closeDialogCreateOrUpdate();
    this.visibleDialog = true;
  }


  closeDialogCreateOrUpdate() {
    this.visibleDialog = false;
    this.dialogTitle = 'Add Product Module';
    this.MaoduleName = '';
    this.MaoduleNumber = '';
    this.description = '';
    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedProductId = null;
    this.selectedParent = null;

  }

  saveDialogCreateOrUpdate() {
    let productModule : ProductModuleRequest = {}  as ProductModuleRequest;
    productModule.moduleName = this.MaoduleName;
    productModule.moduleNumber = this.MaoduleNumber;
    productModule.description = this.description;
    productModule.productId = this.selectedProductId;
    productModule.parentId = this.selectedParent;

    if(this.selectProductModuleId ==null){ 
      
    this.productModuleService.CreateProductModule(productModule).subscribe(
      (data: ProductModule) => {
        this.messageService.add({ severity: 'info', summary: 'Module Created', detail: 'The Product Module created successfully!' });
        this.loadData();
      },  
      (error) => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the Product Module!' });
      }
    );

    }else{
      productModule.id = this.selectProductModuleId;
      // console.log(productModule);
      this.productModuleService.UpdateProductModule(productModule).subscribe(
        (data: ProductModule) => {
          this.messageService.add({ severity: 'info', summary: 'Module Updated', detail: 'The Product Module updated successfully!' });
          this.loadData();
        },
        (error) => {
          console.error(error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating the Product Module!' });
        }
      );


    }

 
    this.closeDialogCreateOrUpdate();
  }

  // edit dialogCreateOrUpdate


  showEditDialog(product: any) {
    
    this.closeDialogCreateOrUpdate();

    this.parentsOptions = this.files.filter(pro => (pro.data.parentId=== null && pro.data.id != product.node.data.id  ) ).map(pro=> pro.data);
    

    this.dialogTitle = 'Edit Product Module';

    this.MaoduleName = product.node.data.moduleName;
    this.MaoduleNumber = product.node.data.moduleNumber;
    this.description = product.node.data.description;
    this.selectedProductId = product.node.data.productId;
    this.selectedParent = product.node.data.parentId;
    this.selectProductModuleId = product.node.data.id;

    // console.log(product.node.data.productCategory);
    // console.log(product.node.data.productType);
    // console.log(product.node.data.productItem);
    

    const categoryGroup = this.categoriesByKind.find(group =>
      group.items.some(item => item.label === product.node.data.productCategory)
    );
    
    // console.log( "categoryGroup:  "+categoryGroup);
    if (categoryGroup) {
      // Find and set the selected category from the group items
      this.selectedCategory = categoryGroup.items.find(
        item => item.label === product.node.data.productCategory
      )?.value; // Access the value property of the matched item
 
      if(this.selectedCategory.category === "Service"){
        product.node.data.productType  = 'service' ;
      }

      // console.log( "selectedCategory:  "+this.selectedCategory);
 
      if (this.selectedCategory) {
        // Set types for the matched category
        this.typesByCategory = this.selectedCategory.types;
 
        // Match and set the selected type by text
        this.selectedType = this.typesByCategory.find(
          type => type.productType === product.node.data.productType
        );
 
        // console.log( "typesByCategory:  "+this.typesByCategory);
        // console.log( "selectedType:  "+this.selectedType);
 
        if (this.selectedType) {
          // Set items for the matched type
          this.itemsByType = this.selectedType.items;
 
          // Match and set the selected item by text
          this.selectedItem = this.itemsByType.find(
            item => item.item === product.node.data.productItem
          );
          

          // console.log( "itemsByType:  "+this.itemsByType);
          // console.log( "selectedItem:  "+this.selectedItem);
       
        }
      }
    }
    
  

    this.visibleDialog = true;

  
  }


// edite dialog
 
populateDropdownGroups() {
  this.categoriesByKind = [
    { label: 'License', items: this.licenseCategories },
    { label: 'Service', items: this.serviceCategories }
  ];
}

private transformCategories(data: ProductResponse): SelectItemGroup[] {
  const licenseTypes: { label: string, value: Category }[] = [];
  const serviceTypes: { label: string, value: Category }[] = [];
 
  // Maps to keep track of categories and their types
  const categoryMap: { [key: string]: Category } = {};

  for (const kind in data) {
    for (const categoryName in data[kind]) {
      const types: Type[] = [];
     
      for (const typeName in data[kind][categoryName]) {
        // Create or update types for the category
        types.push({
          productType: typeName,
          items: data[kind][categoryName][typeName]
        });
      }
     
      // Create or update the category map
      if (!categoryMap[categoryName]) {
        categoryMap[categoryName] = {
          category: categoryName,
          types: types
        };
      } else {
        // Merge types if the category already exists
        categoryMap[categoryName].types.push(...types);
      }
    }
  }

  // Separate categories into License and Service
  Object.keys(categoryMap).forEach(categoryName => {
    const category = categoryMap[categoryName];
    if (categoryName.toLowerCase() === 'service') {
      serviceTypes.push({
        label: category.category,
        value: category
      });
    } else {
      licenseTypes.push({
        label: category.category,
        value: category
      });
    }
  });
  this.groupedCategories = [
    {
      label: 'License Categories:',
      items: licenseTypes
    },
    {
      label: 'Service Categories:',
      items: serviceTypes
    }
  ];

  return this.groupedCategories;
}
  



}
